global = exports ? (window.CoffeeKup ?= {})

beget = (obj) ->
	F = ->
	F.prototype = obj
	new F()

global.CoffeeKup = class _CoffeeKup
	_doctypes:
		'5': '<!DOCTYPE html>'
		'xml': '<?xml version="1.0" encoding="utf-8" ?>'
		'default': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">'
		'transitional': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">'
		'strict': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
		'frameset': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Frameset//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-frameset.dtd">'
		'1.1': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1//EN" "http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd">',
		'basic': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML Basic 1.1//EN" "http://www.w3.org/TR/xhtml-basic/xhtml-basic11.dtd">'
		'mobile': '<!DOCTYPE html PUBLIC "-//WAPFORUM//DTD XHTML Mobile 1.2//EN" "http://www.openmobilealliance.org/tech/DTD/xhtml-mobile12.dtd">'

	_tags: 'a|abbr|acronym|address|applet|area|article|aside|audio|b|base|basefont|bdo|big|blockquote|body|br|button|canvas|caption|center|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hgroup|hr|html|i|iframe|img|input|ins|keygen|kbd|label|legend|li|link|map|mark|menu|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|u|ul|video|xmp'.split '|'

	_selfClosing: ['area', 'base', 'basefont', 'br', 'col', 'frame', 'hr', 'img', 'input', 'link', 'meta', 'param']

	_support: '''
		var __slice = Array.prototype.slice;
		var __hasProp = Object.prototype.hasOwnProperty;
		var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
		var __extends = function(child, parent) {
			for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; }
			function ctor() { this.constructor = child; }
			ctor.prototype = parent.prototype; child.prototype = new ctor; child.__super__ = parent.prototype;
			return child;
		};
		var __indexOf = Array.prototype.indexOf || function(item) {
			for (var i = 0, l = this.length; i < l; i++) {
				if (this[i] === item) return i;
			}
			return -1;
		};
	'''

	_htmlEscape: (txt) -> String(txt).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

	_escape: (txt) -> if @_options.autoescape then @_htmlEscape(txt) else String(txt)

	_renderAttrs: (attrs) -> (" #{key}=\"#{@_escape val ? ''}\"" for key, val of attrs ? {}).join('')

	_repeat: (string, count) -> Array(count + 1).join string

	_indent: -> @text @_repeat '  ', @_tabs if @_options.format

	_extend: (options, args) ->
		obj = beget this
		obj.templates = beget this.templates
		obj._options = options if options?
		obj._buffer = options._buffer ? []
		obj._tabs = options._tabs ? 0

		if options?.locals
			for key, val of options.locals
				obj[key] = val

		obj.__context = options?.context ? options?.__context ? {}
		obj.__arguments = args ? options?.arguments ? options?.__arguments ? []

		return obj

	_makeTag: (tag) -> (opts...) ->
		@tag tag, opts...
		null

	for tag in _CoffeeKup::_tags
		@::[tag] = @::_makeTag tag

	constructor: (options = {}) ->
		@_options = options

	doctype: (type = 5) ->
		@text @_doctypes[type]
		@text '\n' if @_options.format

	coffeescript: (code) ->
		@script ";(#{code})();"

	comment: (cmt) ->
		@text "<!--#{cmt}-->"
		@text '\n' if @_options.format

	h: (txt) -> @_htmlEscape txt

	text: (txt) ->
		@_buffer.push String(txt)

	tag: (name, args...) ->
		@_indent()
		@text "<#{name}"

		for o in args
			if typeof o == 'object'
				@text @_renderAttrs o

		if name in @_selfClosing
			@text " />"
			@text "\n" if @_options.format
		else
			@text ">"
			for o in args
				switch typeof o
					when 'string', 'number'
						@text @_escape o
					when 'function'
						@text "\n" if @_options.format
						@_tabs++
						result = o.call @__context
						if typeof result is 'string'
							@_indent()
							@text @_escape result
							@text "\n" if @_options.format
						@_tabs--
						@_indent()
			@text "</#{name}>"
			@text "\n" if @_options.format

	include: (template) ->
		args = _.rest(arguments)
		args.unshift(this)
		template.apply(this, args)

	compile: (template) ->
		(new Function '__ck', """
			#{@_support}

			return function(__options) {
				var __arguments = _.rest(arguments);
				var __locals = __ck._extend(__options, __arguments);
				with (__locals) {
					(#{template.toString()}).apply(__context, __arguments);
					return _buffer.join('');
				}
			}
		""")(this)

	render: (template, options) ->
		cached = @compile template

		cached options

global.default = ck = new _CoffeeKup

global.render = (template, options) -> global.default.render template, options

global.compile = (template) -> global.default.compile template



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/surveys/coffeekup.coffee